import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { FaTimes, FaPaperPlane, FaCheckCircle } from 'react-icons/fa';
import { useQuoteModal } from '../../context/QuoteModalContext';
import './QuoteModal.css';

const TRANSPORT_TYPES = ['Truck Transport', 'Lorry Transport', 'Construction Material', 'Sand & Metal', 'Long Distance Freight', 'Commercial Logistics'];

export default function QuoteModal() {
  const { isOpen, closeQuote } = useQuoteModal();
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  const handleClose = () => {
    closeQuote();
    setTimeout(() => setSubmitted(false), 300);
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="quote-modal__backdrop"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={handleClose}
        >
          <motion.div
            className="quote-modal glass"
            initial={{ opacity: 0, y: 40, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.96 }}
            transition={{ duration: 0.35 }}
            onClick={(e) => e.stopPropagation()}
          >
            <button className="quote-modal__close" onClick={handleClose} aria-label="Close">
              <FaTimes />
            </button>

            {submitted ? (
              <div className="quote-modal__success">
                <FaCheckCircle />
                <h3>Enquiry Received</h3>
                <p>Our dispatch team will call you back shortly to confirm your transport.</p>
                <button className="btn btn-primary" onClick={handleClose}>Close</button>
              </div>
            ) : (
              <>
                <p className="eyebrow">Book Transport</p>
                <h3 className="quote-modal__title">Request A Quote</h3>
                <form className="quote-modal__form" onSubmit={handleSubmit}>
                  <input type="text" placeholder="Full Name" required />
                  <input type="tel" placeholder="Phone Number" required />
                  <select defaultValue="" required>
                    <option value="" disabled>Transport Type</option>
                    {TRANSPORT_TYPES.map((t) => <option key={t}>{t}</option>)}
                  </select>
                  <textarea placeholder="Pickup location, drop location & load details" rows={3} required />
                  <button type="submit" className="btn btn-primary">
                    Send Enquiry <FaPaperPlane />
                  </button>
                </form>
              </>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
